<div class="default-dialog-layout dialog-with-max-width">
    <div class="title">
        Create new folder in <span class="parent-name">{{ data.name }}</span>
    </div>

    <div class="content">
        <form #createFolderForm (ngSubmit)="confirm(newFolderName.value)">
            <cds-form-group>
                <cds-input>
                    <label>New folder name</label>
                    <input #newFolderName required type="text" maxlength="240" />
                </cds-input>
            </cds-form-group>
            <div class="actions action-buttons form-action-buttons">
                <cds-button size="sm" action="flat" type="button" (click)="cancel()"
                    >Cancel</cds-button
                >
                <cds-button size="sm" type="submit" [disabled]="!createFolderForm.checkValidity()">
                    Create
                </cds-button>
            </div>
        </form>
    </div>
</div>
